import { render, staticRenderFns } from "./ReportImageTire.vue?vue&type=template&id=8ac83330&scoped=true"
import script from "./ReportImageTire.vue?vue&type=script&lang=ts"
export * from "./ReportImageTire.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageTire.vue?vue&type=style&index=0&id=8ac83330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac83330",
  null
  
)

export default component.exports